module.exports = __webpack_public_path__ + "img/1.75004a74.png";